export const getBlogPosts = (language) => {
  const posts = [
    {
      slug: 'por-que-o-email-marketing-morreu-para-recuperacao',
      title: language === 'pt' ? 'O E-mail Marketing Morreu para Carrinhos Abandonados?' : 'Is Email Marketing Dead for Cart Recovery?',
      published_at: '2026-01-08',
      tags: ['Strategy', 'WhatsApp', 'Conversion'],
      excerpt: language === 'pt' 
        ? 'A taxa de abertura caiu para 20%. Veja por que a troca para mensageria instantânea (WhatsApp) não é tendência, é sobrevivência.'
        : 'Open rates dropped to 20%. See why switching to instant messaging (WhatsApp) isn\'t a trend, it\'s survival.',
      content: language === 'pt' ? `
O "spray and pray" do e-mail marketing não funciona mais para recuperação de vendas urgentes. Quando um cliente abandona um carrinho, o interesse dele tem uma meia-vida de minutos, não dias.

### A Guerra da Atenção
Enquanto sua caixa de e-mail recebe 100 spams por dia, seu WhatsApp recebe mensagens de amigos e família. Onde você acha que sua marca será vista primeiro?

Os dados mostram:
* **E-mail:** 20% taxa de abertura, 2 horas para visualizar.
* **WhatsApp:** 98% taxa de abertura, 3 minutos para visualizar.

### O Modelo Híbrido
Não estamos dizendo para cancelar o Mailchimp. Use e-mail para branding e newsletters. Mas para **dinheiro na mesa** (carrinho, checkout, lead quente), a automação via WhatsApp é obrigatória.
      ` : `English content placeholder...`
    },
    {
      slug: 'atendimento-hibrido-ia-humanos',
      title: language === 'pt' ? 'Atendimento Híbrido: Onde a IA termina e o Humano começa' : 'Hybrid Support: Where AI Ends and Humans Begin',
      published_at: '2025-12-28',
      tags: ['AI', 'Support', 'Cost-Efficiency'],
      excerpt: language === 'pt' 
        ? 'O medo de substituir humanos por robôs é real, mas infundado. Descubra como criar a passagem de bastão perfeita.'
        : 'The fear of replacing humans with robots is real but unfounded. Discover how to create the perfect handover.',
      content: language === 'pt' ? `
Muitas empresas falham na automação porque tentam fazer a IA resolver 100% dos casos. O segredo não é substituição, é triagem.

### A Regra 80/20
80% dos chamados são repetitivos: "Onde está meu pedido?", "Como emito 2ª via?". Isso é trabalho de robô.
20% são complexos: "Meu produto veio quebrado e estou frustrado". Isso é trabalho de humano.

### O Transbordo Invisível
Na ProcessSurge, configuramos o que chamamos de "Silent Handover". A IA tenta resolver. Se detectar sentimento negativo ou complexidade, ela resume o caso e passa para um humano no mesmo chat, sem o cliente perceber a ruptura.
      ` : `English content placeholder...`
    },
    {
      slug: 'psicologia-do-abandono',
      title: language === 'pt' ? 'A Psicologia por trás do Abandono de Carrinho' : 'The Psychology Behind Cart Abandonment',
      published_at: '2025-12-15',
      tags: ['E-commerce', 'Psychology', 'Sales'],
      excerpt: language === 'pt' 
        ? 'Não é só o frete. Entenda os gatilhos mentais que fazem seu cliente desistir no último segundo.'
        : 'It\'s not just shipping costs. Understand the mental triggers that make your customer quit at the last second.',
      content: language === 'pt' ? `
O cliente não abandona o carrinho porque odeia seu produto. Ele abandona porque a **fricção cognitiva** superou o **desejo de compra**.

### Os 3 Vilões Invisíveis

1. **Surpresa de Custo:** Frete ou taxas aparecendo só no final.
2. **Fadiga de Decisão:** Pedir cadastro longo antes de mostrar o preço final.
3. **Segurança:** Falta de logos de confiança no checkout.

A recuperação via WhatsApp funciona porque atua como um "empurrãozinho" externo, quebrando a inércia e trazendo o cliente de volta ao estado emocional de compra.
      ` : `English content placeholder...`
    },
    {
      slug: 'api-first-business',
      title: language === 'pt' ? 'Por que empresas "API-First" crescem mais rápido' : 'Why API-First Companies Grow Faster',
      published_at: '2025-11-30',
      tags: ['Tech', 'Scaling', 'Integration'],
      excerpt: language === 'pt' 
        ? 'Seus dados estão presos em silos? Veja como a integração fluida entre ERP e Marketing muda o jogo.'
        : 'Are your data stuck in silos? See how fluid integration between ERP and Marketing changes the game.',
      content: language === 'pt' ? `
Antigamente, você comprava uma suíte gigante que fazia tudo (mal). Hoje, você usa o melhor CRM, o melhor ERP e o melhor Marketing. O desafio? Fazer eles conversarem.

Empresas que tratam integração como produto interno (API-First) conseguem:
* Saber o LTV real do cliente.
* Pausar anúncios quando o estoque do ERP acaba (em tempo real).
* Personalizar ofertas com base no histórico de suporte.
      ` : `English content placeholder...`
    },
     {
      slug: 'anti-spam-whatsapp',
      title: language === 'pt' ? 'Como vender no WhatsApp sem ser banido (Anti-Spam)' : 'Selling on WhatsApp Without Getting Banned',
      published_at: '2025-11-12',
      tags: ['Compliance', 'WhatsApp', 'Best Practices'],
      excerpt: language === 'pt' 
        ? 'A linha tênue entre persistência e incômodo. Nossas regras de ouro para manter a saúde do seu número.'
        : 'The fine line between persistence and annoyance. Our golden rules for keeping your number healthy.',
      content: language === 'pt' ? `
O maior medo de quem automatiza é perder o número. E com razão. O Meta é implacável com spam.

### Nossos Pilares de Segurança

1. **Opt-in Explícito:** Só mandamos mensagem se o cliente iniciou o checkout (legítimo interesse).
2. **Stop Rule:** Se o cliente disser "Pare", a IA nunca mais manda mensagem. Imediatamente.
3. **Janela de 24h:** Respeitamos rigorosamente as janelas de conversação da API Oficial.
      ` : `English content placeholder...`
    }
  ];

  return posts;
};

export const getBlogPostBySlug = (slug, language) => {
  const posts = getBlogPosts(language);
  return posts.find((post) => post.slug === slug);
};
